import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExtraModule, getEnabledModules } from '../helpers/extra-modules';

export default function ExtraModuleLinks({ userId }: { userId?: string }) {
  const [modules, setModules] = useState<ExtraModule[]>([]);
  useEffect(() => {
    let active = true;
    setModules([]);
    if (userId) getEnabledModules().then(items => {
      if (active && Array.isArray(items)) setModules(items);
    }).catch(() => { if (active) setModules([]); });
    return () => { active = false; };
  }, [userId]);
  return <>{modules.filter(m => m.appPath).map(m => <Link key={m.key} to={m.appPath!} className="underline mx-3">{m.name}</Link>)}</>;
}
